import React, { useState, useRef, useEffect } from "react";
import styled, { keyframes } from "styled-components";

import typographySizes from "styles/typographySizes.js";
import mediaQuery from "styles/mediaQuery.js";
import distances from "styles/distances.js";
import { ContextConsumer } from "layouts/Context.js";
import colors from "styles/colors.js";
import SectionIntro from "components/global/typography/heading/SectionIntro.js";
import Btn from "components/global/Btn.js";
import { use100vh } from "react-div-100vh";

const All = styled.div`
  @media (max-width: ${mediaQuery.tablet}) {
    &.hide {
      display: none;
    }
  }
`;

const Cover = styled.div`
  position: fixed;
  left: 0;
  top: 0;
  background-color: black;
  opacity: 0;
  height: 100vh;
  height: 100dvh;
  width: 100vw;
  z-index: 999998;
  pointer-events: none;
  transition: all 0.5s cubic-bezier(0.65, 0, 0.35, 1);
  &.open {
    opacity: 0.8;
    pointer-events: all;
    transition: all 0.5s cubic-bezier(0.65, 0, 0.35, 1);
  }
  @media (max-width: ${mediaQuery.tablet}) {
    z-index: 997;
    height: initial;;
  }
`;

const Wrapper = styled.div`
  position: fixed;
  right: 0%;
  height: 100vh;
  height: 100dvh;
  top: 0;
  z-index: 999999;
  background-color: ${colors.white}; 

width: 0;
  overflow: scroll;
  transition: all 0.5s cubic-bezier(0.65, 0, 0.35, 1);

  &.open {
 width: 56rem;
    transition: all 0.5s cubic-bezier(0.65, 0, 0.35, 1);
  }
  @media (max-width: ${mediaQuery.tablet}) {

    &.open {
      width: 100vw;
    }
  }
`;

const FormWrapper = styled.div`
  background-color: ${colors.white};
  height: 100vh;
  height: 100dvh;
width:  56rem;
padding: 2rem;
box-sizing: border-box;
display: flex;
flex-direction: column;
justify-content: space-between;
overflow: hidden;

&.confirmation {
  /* justify-content: center;
  align-items: center; */
}

.confirmation-title {
 margin-right: 8rem;
}

.btn-submit {
  background-color: ${colors.yellow};
width: 100%;
height: 6rem;
border: solid 0.1rem ${colors.dark};

}

.btn-text-visible,
.btn-text-hidden{
  line-height: 6rem;
  font-size: 2rem;
  text-align: center;
  margin: 0 auto !important;
}

.btn-text-hidden{
  left: 50%;
  transform: translateX(-50%);
}

  @media (max-width: ${mediaQuery.tablet}) {
    height: initial;
    width: 100vw;
  }
`;

const OrderForm = styled.form`
  width: 100%;


`;
const InputWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 0.5rem;
  margin-bottom: 2rem;
  @media (max-width: ${mediaQuery.tablet}) {
    grid-template-columns: 1fr;
    margin-top: 6rem;
  }
`;

const FieldWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

const StyledLabel = styled.label`
  font-size: ${typographySizes.text.small.size.desktop}rem;
  color: ${colors.dark};
  margin-bottom: 0.2rem;
  display: block;
  text-transform: uppercase;
  text-align: left;
`;

const StyledInput = styled.input`
  all: unset;
  display: inline;
  padding: 1rem;
  color: ${colors.dark};
  font-size: ${typographySizes.text.small.size.desktop}rem !important;
  -webkit-appearance: none;
  appearance: none;
  background-color: transparent;
  border: solid ${colors.dark} 0.1rem;
  text-transform: uppercase;


  &::placeholder {
    all: unset;
    color: ${colors.dark}40;
  }
  ::autofill {
    background-color: transparent;
  }
  :valid {
    background-color: transparent;
  }
`;

const CheckboxCategory = styled.div`
margin-bottom: 2rem;
  width: 100%;
`;

const CategoryTitle = styled.h4`
  font-size: ${typographySizes.text.small.size.desktop}rem;
  color: ${colors.dark};
  width: 100%;
  margin-bottom: 0.2rem;
  text-align: left;
`;

const CheckboxWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 0.5rem;
  width: 100%;
`;

const StyledCheckmark = styled.span`
  display: block;
  position: relative;
width: 100%;
text-align: center; 
  vertical-align: middle;
  padding: 1.2rem 2.2rem;
  cursor: pointer;
  color: ${colors.dark};
  border: solid 0.1rem ${colors.dark};
  background-color: ${colors.white}; 



  &.disabled {
    opacity: 0.2;
  }
`;

const PersonaCheckmarkWrapper = styled.label`
  display: flex;
  justify-content: center;
align-items: center;
  font-size: ${typographySizes.ss}rem !important;
  color: ${colors.dark};
  margin-top: 0rem;
  position: relative;
  overflow: hidden;
  width: 100%;
  :first-of-type {
  }

  input {
    /* display: none; */
    top: 0.5rem;
    left: -4rem;
    position: absolute;
    border-radius: 0;
    /* -webkit-appearance: none; */
  }

  input:checked + ${StyledCheckmark} {
    border: solid 0.1rem ${colors.dark};
    background-color: ${colors.blue};
    color: ${colors.white};
  }
`;

const StyledTextarea = styled.textarea`
  width: 100%;
  height: 10rem;
  border: solid 0.1rem ${colors.dark};
color: ${colors.dark};
box-sizing: border-box;
  font-size: ${typographySizes.s}rem !important;
  padding: 1rem;
  margin-bottom: 2rem;
  &::placeholder {
    all: unset;
    color: ${colors.dark}40;
    text-transform: uppercase;
  }
`;

const ProductOrderBottomWrapper = styled.div``;

const StyledCheckmarkGdpr = styled.span`
  display: block;
  position: relative;
flex-shrink: 0;
  width: 3rem;
  height: 3rem;  
text-align: center;
  margin-right: 2rem;  
  cursor: pointer;
  border: solid 0.1rem ${colors.dark};
background-color: ${colors.white}; ;
z-index: 1;

  &::before {
    content: "";
    position: absolute;
    width: 0rem;
    left: 50%;
    top: 50%;
    height: 0.6rem;
    transform: translate(-50%, -50%) rotate(45deg);
    background-color: ${colors.dark};
    transition: all 0.5s cubic-bezier(0.65, 0, 0.35, 1);
  }
  &::after {
    content: "";
    position: absolute;
    width: 0rem;
    left: 50%;
    top: 50%;
    height: 0.6rem;
    transform: translate(-50%, -50%) rotate(-45deg);
    background-color: ${colors.dark};
    transition: all 0.5s cubic-bezier(0.65, 0, 0.35, 1);
  }
`;

const PersonaCheckmarkWrapperGdpr = styled.label`
  display: flex;
  margin-bottom: 2rem;
  font-size: ${typographySizes.ss}rem !important;
  position: relative;
  color: ${colors.dark};
font-size: ${typographySizes.text.extraSmall.size.desktop}rem !important;
line-height: ${typographySizes.text.extraSmall.lineHeight} !important;
text-transform: uppercase;

input{
  position: absolute;
}


  input:checked + ${StyledCheckmarkGdpr} {
    &::after {
      width: 80%;
    }
    &::before {
      width: 80%;
    }
  }
`;

const CloseBtn = styled.button`
  position: absolute;
  top: 0.5rem;
  left: 48rem;
  width: 8rem;
  height: 8rem;
  background: none;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  transition: all 0.3s ease;
  
  &::before,
  &::after {
    content: '';
    position: absolute;
    width: 5rem;
    height: 0.4rem;
    background-color: ${colors.dark};
    transition: all 0.3s ease;
  }
  
  &::before {
    transform: rotate(45deg);
  }
  
  &::after {
    transform: rotate(-45deg);
  }
  
  &:hover{
    rotate: 90deg;
    transition: all 0.3s ease;
  }
  
  @media (max-width: ${mediaQuery.tablet}) {
    width: 5rem;
    height: 5rem;
    left: calc(100vw - 6rem);
    top: 1.6rem;
    &::before,
  &::after {

    width: 3rem;
    height: 0.3rem;
  }

  }
`;

const ContactForm = ({ navOpen, colorBg, colorText, hide }) => {
  const [confirmation, setConfirmation] = useState(false);

  const handleSubmit = (event) => {
    event.preventDefault();
    setConfirmation(true);
    const formData = new FormData(event.target);
    const formObject = {};

    formData.forEach((value, key) => {
      formObject[key] = value;
    });

    // Use only Polish submission ID
    const submissionId = "J6xzExKgH";
    fetch(`https://submit-form.com/${submissionId}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify(formObject),
    })
      .then(function (response) {
        console.log(response);
      })
      .catch(function (error) {
        console.error(error);
      });
  };

  return (
    <ContextConsumer>
      {({ data, set }) => {
        const openForm = data.contactFormOpen || false;
        const setOpenForm = (isOpen) => set({ contactFormOpen: isOpen });
        const buttonTopText = openForm ? "zamknij" : "zaplanuj projekt";

        return (
          <All className={hide && "hide"}>
            <Cover
              onClick={() => setOpenForm(!openForm)}
              className={openForm && "open"}
            />
            <Wrapper className={openForm && !data.navOpen && "open"}>
              {confirmation ? (
                <FormWrapper className="confirmation">
                  <CloseBtn onClick={() => setOpenForm(false)} />
                  <div>
                    <SectionIntro
                      className="confirmation-title"
                      title="CZEKAJ NA
                    NASZ RUCH."
                      color={colors.white}
                      subtitle_v1="mamy"
                      subtitle_v2="to"
                    />
                  </div>
                </FormWrapper>
              ) : (
                <FormWrapper>
                  <CloseBtn onClick={() => setOpenForm(false)} />
                  <SectionIntro
                    title="Zróbmy coś razem"
                    color={colors.white}
                    subtitle_v1="napisz"
                    subtitle_v2="wiadomość"
                  />
                  <OrderForm onSubmit={handleSubmit}>
                    <InputWrapper>
                      <FieldWrapper>
                        <StyledLabel htmlFor="Name">Imię </StyledLabel>
                        <StyledInput
                          type="text"
                          id="Name"
                          name="Name"
                          required
                          placeholder="Podaj swoje imię"
                        />
                      </FieldWrapper>
                      <FieldWrapper>
                        <StyledLabel htmlFor="Company">Nazwa firmy</StyledLabel>
                        <StyledInput
                          type="text"
                          id="Company"
                          name="Company"
                          placeholder="Podaj nazwę firmy"
                        />
                      </FieldWrapper>
                      <FieldWrapper>
                        <StyledLabel htmlFor="email">Email </StyledLabel>
                        <StyledInput
                          type="email"
                          id="email"
                          name="email"
                          required
                          placeholder="Podaj swój email"
                        />
                      </FieldWrapper>
                      <FieldWrapper>
                        <StyledLabel htmlFor="tel">Numer telefonu</StyledLabel>
                        <StyledInput
                          type="tel"
                          id="tel"
                          name="tel"
                          placeholder="Podaj swój numer telefonu "
                        />
                      </FieldWrapper>
                    </InputWrapper>
                    <CheckboxCategory>
                      <CategoryTitle>
                        Co możemy dla Ciebie zrobić?
                      </CategoryTitle>
                      <CheckboxWrapper>
                        <PersonaCheckmarkWrapper>
                          <input name="PRODUKCJA" type="checkbox" />
                          <StyledCheckmark>PRODUKCJA</StyledCheckmark>
                        </PersonaCheckmarkWrapper>
                        <PersonaCheckmarkWrapper>
                          <input name="SOCIAL MEDIA" type="checkbox" />
                          <StyledCheckmark>SOCIAL MEDIA</StyledCheckmark>
                        </PersonaCheckmarkWrapper>
                        <PersonaCheckmarkWrapper>
                          <input name="BRANDING" type="checkbox" />
                          <StyledCheckmark>BRANDING</StyledCheckmark>
                        </PersonaCheckmarkWrapper>
                        <PersonaCheckmarkWrapper>
                          <input name="COŚ INNEGO" type="checkbox" />
                          <StyledCheckmark>COŚ INNEGO</StyledCheckmark>
                        </PersonaCheckmarkWrapper>
                      </CheckboxWrapper>
                    </CheckboxCategory>
                    <FieldWrapper>
                      <StyledLabel htmlFor="description">
                        Napisz cos o projekcie
                      </StyledLabel>
                      <StyledTextarea
                        placeholder="Opisz swój projekt"
                        id="description"
                        name="description"
                        cols="50"
                      />
                    </FieldWrapper>
                    <ProductOrderBottomWrapper>
                      <PersonaCheckmarkWrapperGdpr>
                        <input name="Gdpr" type="checkbox" required />
                        <StyledCheckmarkGdpr />
                        Wyrażam zgodę na przetwarzanie moich danych osobowych
                        zgodnie z ustawą o ochronie danych osobowych w związku z
                        realizacją zgłoszenia. Podanie danych jest dobrowolne,
                        ale niezbędne do przetworzenia zapytania. Zostałem/am
                        poinformowany/a, że przysługuje mi prawo dostępu do
                        swoich danych, możliwości ich poprawiania, żądania
                        zaprzestania ich przetwarzania. Administratorem danych
                        osobowych jest we3studio s.c. ul. Mokotowska 52a, m27,
                        00-543 Warszawa.
                      </PersonaCheckmarkWrapperGdpr>
                      <Btn className="btn-submit" type="submit">
                        wyślij wiadomość
                      </Btn>
                    </ProductOrderBottomWrapper>
                  </OrderForm>
                </FormWrapper>
              )}
            </Wrapper>
          </All>
        );
      }}
    </ContextConsumer>
  );
};

export default ContactForm;
